import React, { useEffect, useRef, useState } from 'react'
import Accordion from '../../atoms/Accordion/Accordion'
import Tabs from '../Tabs/Tabs'
import { Larghezza, Download, Goccia, Altezza } from '../../atoms/NewIcons'
import Button from '../../atoms/Button/Button'
import { api } from '../../../utils'
import { Trans } from '../../atoms'
import { ChevronDown, Imballi } from './../../atoms/NewIcons'
import { COSTIPERSONALIZZAZIONE, PERSONALIZZAZIONI, PRODOTTI } from '../../../utils/endpoint'
import useTrans from '../../../hooks/useTrans'
import DettagliProdottoListino from '../DettagliProdottoListino/DettagliProdottoListino'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'
import useDownloadFromApi from '../../../hooks/useDownloadFromApi'
import LoadingSvg from '../../atoms/Loading/Loading'
import Color from '../../atoms/Color/Color'

const DettagliProdottoRecapItem = ({ label, value }) => {
  return (
    <div className="dettagli-prodotto__recap__item">
      <p className="dettagli-prodotto__recap__label">{label}:</p>
      <div className="dettagli-prodotto__recap__value">{value}</div>
      <span className="dettagli-prodotto__recap__arrow">
        <ChevronDown />
      </span>
    </div>
  )
}

const DettagliProdottoData = ({ label, value, html = false }) => {
  return (
    <div className="dettagli-prodotto__data">
      <p className="dettagli-prodotto__data__label">{label}</p>
      {html ? (
        <div
          className="dettagli-prodotto__data__value"
          dangerouslySetInnerHTML={{
            __html: value,
          }}
        />
      ) : (
        <p className="dettagli-prodotto__data__value">{value}</p>
      )}
    </div>
  )
}

const DettagliProdottoDocumentazioneButton = ({
  label,
  url,
  filename,
  downloading,
  saveFile,
  fromApi,
}) => {
  return fromApi ? (
    <div className="dettagli-prodotto__documentazione__button-wrap">
      <a
        href={url}
        onClick={(e) => {
          e.preventDefault()
          if (downloading) return
          saveFile(filename, url, filename)
        }}
        disabled={downloading ? true : false}
      >
        <Button
          label={label}
          icon={downloading == filename ? <LoadingSvg /> : <Download />}
          icon_pos="left"
          variant="ghost"
          color="black"
          size="medium"
          disabled={downloading ? true : false}
        />
      </a>
    </div>
  ) : (
    <div className="dettagli-prodotto__documentazione__button-wrap">
      <a href={url} download target="_blank">
        <Button
          label={label}
          icon={<Download />}
          icon_pos="left"
          variant="ghost"
          color="black"
          size="medium"
        />
      </a>
    </div>
  )
}

const DettagliProdotto = ({
  selectedItem,
  selectedColor,
  selectedTaglia,
  prodotto,
  selectorTaglia,
  selectorColore,
}) => {
  const [prezzi, setPrezzi] = useState({})
  const [pers, setPers] = useState(null)
  const [open, setOpen] = useState(false)
  const t = useTrans()
  const refTableSchedaProdotto = useRef(null)
  const router = useRouter()
  const { service_gift } = useSelector((state) => state.servicegift)
  const { downloading, saveFile } = useDownloadFromApi()

  useEffect(() => {
    let params = {
      lang: router.locale,
    }
    api.get(`${PRODOTTI}${prodotto.codice}${COSTIPERSONALIZZAZIONE}`, { params }).then((data) => {
      setPrezzi(data.data)
    })
    api
      .get(`${PRODOTTI}${prodotto.codice}${PERSONALIZZAZIONI}`, { params })
      .then((data) => setPers(data.data))
  }, [])

  const articoliWithEan = prodotto?.articoli?.filter((x) => x?.ean !== null) || [];

  return (
    <div className="dettagli-prodotto">
      <div className="dettagli-prodotto__header">
        <h3 className="dettagli-prodotto__title">
          <Trans chiave="Dettagli prodotto" />
        </h3>
        <div className="dettagli-prodotto__subtitle">
          <p>
            <Trans chiave="Trova tutti i dettagli dell'articolo" />
          </p>
          <p>
            <Trans chiave="Puoi selezionare una referenza di tuo interesse per visualizzarne le relative informazioni" />
          </p>
        </div>
      </div>

      <div className="dettagli-prodotto__recap">
        {selectedColor &&
          (selectorColore ? (
            selectorColore
          ) : (
            <DettagliProdottoRecapItem label={t('Colore')} value={selectedColor?.nome} />
          ))}
        {selectedTaglia &&
          (selectorTaglia ? (
            selectorTaglia
          ) : (
            <DettagliProdottoRecapItem label={t('Taglia')} value={selectedTaglia?.nome} />
          ))}
      </div>

      <div className="dettagli-prodotto__accordions">
        <Accordion placeholder={t('Specifiche')} size="extralarge">
          <div className="dettagli-prodotto__accordion-content">
            <div className="dettagli-prodotto__data-list">
              <DettagliProdottoData label={t('Codice articolo')} value={selectedItem?.codice} />
              <DettagliProdottoData label={t('Colore')} value={selectedColor?.nome} />
              <DettagliProdottoData
                label={t('Colori disponibili')}
                value={prodotto.colori.map((item) => item?.nome).join(', ')}
              />
              <DettagliProdottoData
                label={t('Descrizione')}
                value={
                  selectedItem?.descrizione_lunga
                    ? selectedItem?.descrizione_lunga
                    : selectedItem?.descrizione
                }
                html={selectedItem?.descrizione_lunga ? true : false}
              />
              {prodotto.materiale && (
                <DettagliProdottoData label={t('Materiale')} value={prodotto.materiale?.nome} />
              )}

              {prodotto.taglie.length > 0 && selectedTaglia && (
                <DettagliProdottoData
                  label={t('Taglie disponibili')}
                  value={prodotto.taglie
                    .filter((item) => item.id != selectedTaglia.id)
                    .map((item) => item?.nome)
                    .join('/')}
                />
              )}

              {selectedItem?.attributi_lista.filter((item) => item.attributo_chiave == 'manico')
                .length > 0 && (
                  <DettagliProdottoData
                    label={t('Misure manico')}
                    value={
                      selectedItem.attributi_lista.filter(
                        (item) => item.attributo_chiave == 'manico'
                      )[0]?.nome
                    }
                  />
                )}

              {selectedItem?.attributi_lista.filter((item) => item.attributo_chiave == 'capacita')
                .length > 0 && (
                  <DettagliProdottoData
                    label={t('Capacità')}
                    value={
                      <p className="dettagli-prodotto__capacita">
                        <span className="dettagli-prodotto__capacita__tag">
                          {
                            selectedItem.attributi_lista.filter(
                              (item) => item.attributo_chiave == 'capacita'
                            )[0]?.nome
                          }
                        </span>
                        <span className="dettagli-prodotto__capacita__label">
                          {
                            selectedItem.attributi_lista.filter(
                              (item) => item.attributo_chiave == 'capacita'
                            )[0]?.nome
                          }
                        </span>
                      </p>
                    }
                  />
                )}
              {prodotto.brand && (
                <DettagliProdottoData
                  label={t('Marchio')}
                  value={
                    <img
                      src={prodotto.brand.image}
                      alt={prodotto.brand.nome}
                      title={prodotto.brand.nome}
                    />
                  }
                />
              )}

              {prodotto.voce_doganale && (
                <DettagliProdottoData
                  label={t('Codice Doganale')}
                  value={prodotto.voce_doganale ? prodotto.voce_doganale : '-'}
                />
              )}
              {!!selectedItem.paese_origine && (
                <DettagliProdottoData
                  label={t('Paese di origine')}
                  value={selectedItem.paese_origine}
                />
              )}

              {prodotto.dimensione_legacy && (
                <DettagliProdottoData label={t('Dimensioni')} value={prodotto.dimensione_legacy} />
              )}

              {selectedItem?.grammatura && (
                <DettagliProdottoData label={t('Grammatura')} value={selectedItem.grammatura} />
              )}

              {prodotto?.alternativo?.codice && (
                <DettagliProdottoData
                  label={t('Prodotto alternativo')}
                  value={<a href={prodotto.alternativo.url}>{prodotto.alternativo.codice}</a>}
                />
              )}

              {selectedItem?.note && (
                <DettagliProdottoData
                  label={t('Note')}
                  value={selectedItem.note ? selectedItem.note : '-'}
                  html
                />
              )}
            </div>
          </div>
        </Accordion>

        {articoliWithEan && articoliWithEan?.length > 0 &&
          <Accordion placeholder={t('Codici EAN GS1')} size={'extralarge'}>
            <div className={"dettagli-prodotto__ean"}>

              <div className={"dettagli-prodotto__ean__column"}>
                <div className={"dettagli-prodotto__ean__header"}>{t('Codice')}</div>
                {articoliWithEan.map((x) => (
                  <div className={"dettagli-prodotto__ean__element"} key={x?.id}>{x?.codice}</div>
                ))}
              </div>
              {articoliWithEan.some((x) => x?.attributi_lista?.find(attributo => attributo.attributo_chiave === 'colore')) &&
                <div className={"dettagli-prodotto__ean__column"}>
                  <div className={"dettagli-prodotto__ean__header"}>{t('Colore')}</div>
                  {articoliWithEan.map((x) => (
                    <div className={"dettagli-prodotto__ean__element"} key={x?.id}><Color img={x?.attributi_lista?.find(attributo => attributo.attributo_chiave === 'colore')?.image} /></div>
                  ))}
                </div>}
              {articoliWithEan.some((x) => x?.attributi_lista?.find(attributo => attributo.attributo_chiave === 'taglia')) &&
                <div className={"dettagli-prodotto__ean__column"}>
                  <div className={"dettagli-prodotto__ean__header"}>{t('Taglia')}</div>
                  {articoliWithEan.map((x) => (
                    <div className={"dettagli-prodotto__ean__element"} key={x?.id}>{x?.attributi_lista?.find(attributo => attributo.attributo_chiave === 'taglia')?.nome}</div>
                  ))}
                </div>}

              <div className={"dettagli-prodotto__ean__column"}>
                <div className={"dettagli-prodotto__ean__header"}>{t('Codice EAN')}</div>
                {articoliWithEan.map((x) => (
                  <div className={"dettagli-prodotto__ean__element"} key={x?.id}>{x?.ean}</div>
                ))}
              </div>

            </div>
          </Accordion>}

        <Accordion placeholder={t('Info imballi')} size="extralarge">
          <div className="dettagli-prodotto__accordion-content">
            <div className="dettagli-prodotto__data-list">
              {selectedItem?.attributi_lista.filter((item) => item.attributo == 11)[0] && (
                <DettagliProdottoData
                  label={t('Tipo confezione')}
                  value={
                    selectedItem.attributi_lista.filter((item) => item.attributo == 11)[0]?.nome
                  }
                />
              )}
              <DettagliProdottoData
                label={t('Imballi')}
                value={
                  <div className="dettagli-prodotto__imballo">
                    <span className="dettagli-prodotto__imballo__icon">
                      <Imballi />
                    </span>
                    <span className="dettagli-prodotto__imballo__label">
                      {selectedItem?.imballi}
                    </span>
                  </div>
                }
              />
              {selectedItem?.sotto_imballi ? (
                <DettagliProdottoData
                  label={t('Sotto imballi')}
                  value={
                    <div className="dettagli-prodotto__imballo">
                      <span className="dettagli-prodotto__imballo__icon">
                        <Imballi />
                      </span>
                      <span className="dettagli-prodotto__imballo__label">
                        {selectedItem?.sotto_imballi}
                      </span>
                    </div>
                  }
                />
              ) : (
                <></>
              )}
              <DettagliProdottoData
                label={t('Dimensione')}
                value={
                  <div className="dettagli-prodotto__dimensioni">
                    <span className="dettagli-prodotto__dimensioni__tag">
                      {selectedItem?.altezza_imballo}x{selectedItem?.larghezza_imballo}
                      <br />x {selectedItem?.profondita_imballo} cm
                    </span>
                    <span className="dettagli-prodotto__dimensioni__label">
                      {selectedItem?.altezza_imballo} x {selectedItem?.larghezza_imballo} x{' '}
                      {selectedItem?.profondita_imballo} (cm)
                    </span>
                  </div>
                }
              />
              {selectedItem?.volume_imballo ? (
                <DettagliProdottoData
                  label={t('Volume Collo')}
                  value={selectedItem?.volume_imballo}
                />
              ) : (
                <></>
              )}
              {selectedItem?.peso ? (
                <DettagliProdottoData
                  label={t('Peso lordo collo')}
                  value={String(selectedItem?.peso.toFixed(2)).replace('.', ',') + ' Kg'}
                />
              ) : (
                <></>
              )}
            </div>
          </div>
        </Accordion>

        {prodotto.info_smaltimento_imballaggi?.length > 0 && (
          <Accordion placeholder={t('Info per smaltimento imballaggi')} size="extralarge">
            <div className="dettagli-prodotto__accordion-content">
              <div className="dettagli-prodotto__data-list">
                {prodotto.info_smaltimento_imballaggi.map((info) => (
                  <DettagliProdottoData
                    key={`info_smaltimento_imballaggi-${info.nome}`}
                    label={info.nome}
                    value={info.descrizione}
                  />
                ))}
              </div>
              {router.locale == 'it' && (
                <div
                  className="dettagli-prodotto__disclaimer"
                  dangerouslySetInnerHTML={{
                    __html: t(
                      '<strong>** per tutti gli imballaggi verificare le disposizioni del proprio comune per il corretto smaltimento **</strong>'
                    ),
                  }}
                />
              )}
            </div>
          </Accordion>
        )}

        {pers && pers?.tecniche?.length > 0 && (!service_gift || service_gift?.personalizzazione) && (
          <Accordion placeholder={t('Opzioni di personalizzazione')} size="extralarge">
            <div className="dettagli-prodotto__accordion-content">
              <DettagliProdottoTabPersonalizzazione
                pers={pers}
                setOpen={setOpen}
                t={t}
                prodotto={prodotto}
                refTableSchedaProdotto={refTableSchedaProdotto}
              />
            </div>
          </Accordion>
        )}

        {selectedItem &&
          (selectedItem.url_scheda_tecnica ||
            selectedItem.url_scheda_conformita ||
            selectedItem.documenti?.length) ? (
          <Accordion placeholder={t('Documentazione')} size="extralarge">
            <div className="dettagli-prodotto__accordion-content">
              <div className="dettagli-prodotto__documentazione">
                <div className="dettagli-prodotto__documentazione__buttons">
                  {selectedItem.documenti.map((item) => (
                    <DettagliProdottoDocumentazioneButton
                      label={item?.nome}
                      url={`${item.url}`}
                      filename={item.label}
                    />
                  ))}
                  {selectedItem?.url_scheda_tecnica && (
                    <DettagliProdottoDocumentazioneButton
                      label={t('Scarica scheda prodotto in pdf')}
                      url={`${selectedItem.url_scheda_tecnica}`}
                      fromApi
                      downloading={downloading}
                      saveFile={saveFile}
                      filename={`${service_gift?.nome || 'sipec'}-prodotto-${prodotto?.codice}-${selectedItem?.slug
                        }.pdf`}
                    />
                  )}
                  {/* {selectedItem?.url_scheda_conformita && (
                    <DettagliProdottoDocumentazioneButton
                      label={t('Scarica dichiarazione di conformità')}
                      url={`${selectedItem.url_scheda_conformita}`}
                    />
                  )} */}
                </div>
                {/* <Button
                label={t('Scarica tutte le imagini')}
                variant="ghost"
                size="large"
                icon={<ArrowRight />}
                icon_pos="right"
                className="dettagli-prodotto__documentazione__buttons__link"
              /> */}
              </div>
            </div>
          </Accordion>
        ) : (
          ''
        )}
        {pers && pers?.tecniche?.length > 0 && (!service_gift || service_gift?.personalizzazione) && (
          <Accordion
            initialValue={open}
            placeholder={t('Listino prezzi per personalizzazione')}
            size="extralarge"
          >
            <div className="dettagli-prodotto__accordion-content">
              <DettagliProdottoListino
                refTableSchedaProdotto={refTableSchedaProdotto}
                prezzi={prezzi}
                prezziTransfer={null}
              />
            </div>
          </Accordion>
        )}
        <div ref={(el) => (refTableSchedaProdotto.current = el)}></div>
      </div>
    </div>
  )
}

const DettagliProdottoTab = ({ item, setOpen, t, prodotto, refTableSchedaProdotto }) => {
  const HandleVisualizzaPrezzi = () => {
    setOpen(true)
    refTableSchedaProdotto?.current?.scrollIntoView()
  }

  return (
    <div className="dettagli-prodotto__data-list">
      <DettagliProdottoData label={t('Tecnica di stampa')} value={item?.nome} />
      <DettagliProdottoData
        label={t('Posizione di stampa consigliata')}
        value={item.posizioni[0]?.nome}
      />
      <DettagliProdottoData
        label={t('Max. misure di stampa')}
        value={
          <div className="dettagli-prodotto__misure">
            <span className="dettagli-prodotto__misure__item">
              <span className="dettagli-prodotto__misure__icon">
                <Altezza />
              </span>
              <span className="dettagli-prodotto__misure__label">
                {item.posizioni[0].numero_colori[0].personalizzazioni_objects[0].altezza_massima} cm
              </span>
            </span>
            <span className="dettagli-prodotto__misure__item">
              <span className="dettagli-prodotto__misure__icon">
                <Larghezza />
              </span>
              <span className="dettagli-prodotto__misure__label">
                {item.posizioni[0].numero_colori[0].personalizzazioni_objects[0].base_massima} cm
              </span>
            </span>
          </div>
        }
      />
      <DettagliProdottoData
        label={t('Max. numero colori di stampa')}
        value={
          <div className="dettagli-prodotto__colori">
            <p className="dettagli-prodotto__colori__row">
              <span className="dettagli-prodotto__colori__icon">
                {item.posizioni[0].numero_colori.length > 0 ? (
                  [...Array(item.posizioni[0].numero_colori.length)].map((k) => <Goccia key={k} />)
                ) : (
                  <></>
                )}
              </span>
              <span className="dettagli-prodotto__colori__label">
                {item.posizioni[0].numero_colori.length > 0 &&
                  item.posizioni[0].numero_colori[0].codice === '000'
                  ? item.posizioni[0].numero_colori[0].nome
                  : item.posizioni[0].numero_colori.length}
              </span>
            </p>
            <div className="dettagli-prodotto__colori__show-prezzi">
              <a onClick={() => HandleVisualizzaPrezzi()}>
                <Trans chiave="Visualizza prezzi" />
              </a>
            </div>
          </div>
        }
      />
      {prodotto?.attributi_lista?.filter(
        (attributo) => attributo?.attributo_chiave === 'confezionamento'
      ).length > 0 && (
          <DettagliProdottoData
            label={t('Tipo confezionamento dopo personalizzazione')}
            value={
              prodotto?.attributi_lista?.filter(
                (attributo) => attributo?.attributo_chiave === 'confezionamento'
              )[0]?.nome
            }
          />
        )}
    </div>
  )
}

const DettagliProdottoTabPersonalizzazione = ({
  pers,
  setOpen,
  t,
  prodotto,
  refTableSchedaProdotto,
}) => {
  if (!pers || !pers.tecniche?.length) {
    return <></>
  }
  let data = pers.tecniche.map((item) => ({
    label: item?.nome,
    id: item.id,
    component: () => (
      <DettagliProdottoTab
        setOpen={setOpen}
        item={item}
        t={t}
        prodotto={prodotto}
        refTableSchedaProdotto={refTableSchedaProdotto}
      />
    ),
  }))
  return <Tabs tabs={data} />
}

export default React.memo(DettagliProdotto)
